import React, { useContext, useState, useRef, useEffect } from "react";
import data from "../language.json";
import languageContext from "../context/language/languageContext";
import Question from "./Question";
import Answer from "./Answer";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Ask = ({ bookappointment, setbookappointment }) => {
  const {
    setSessionTimeout,
    dataApi,
    setData,
    setAlert,
    setMessage,
    isRightPanel,
    setIsRightPanel,
  } = useContext(languageContext);
  const [visible, setVisible] = useState(true);
  const [interactions, setInteractions] = useState([]);
  const [session, setsession] = useState({});
  const [input, setInput] = useState("");
  const mainBoxRef = useRef(null);
  const navigate = useNavigate();
  const lang = localStorage.getItem("lang");

  const gettingResponse = async (text) => {
    let headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify({
      question: text,
      qcare:true,
      session: session,
      lang: data[lang]["name"],
    });

    try {
      let response = await axios.post(
        "https://www.careplus.gopillz.com/warden_al_voice_chat_webside",
        bodyContent,
        { headers: headersList }
      );
      if (response.data.ans !== "") {
        setInteractions((prev) => [
          ...prev,
          { type: "answer", text: response.data.ans, audio: null },
        ]);
        setData((prevData) => [
          ...prevData,
          { type: "answer", text: response.data.ans },
        ]);
        setsession(response.data.session);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data.detail === "Token has expired"
      ) {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("Please try again later, something went wrong");
      }
    }
  };

  const askQuestion = (text) => {
    if (text !== "") {
      setData((prevData) => [...prevData, { type: "question", text: text }]);
      setInteractions((prev) => [
        ...prev,
        { type: "question", text: text, audio: null },
      ]);
      gettingResponse(text);
      setInput("");
    }
  };

  const handleText = (e) => {
    setInput(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      askQuestion(input);
    }
  };

  useEffect(() => {
    if (mainBoxRef.current) {
      mainBoxRef.current.scrollTop = mainBoxRef.current.scrollHeight;
    }
  }, [interactions]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-white to-indigo-50 p-4">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-6">
        {/* Chat Box */}
        <div className="flex flex-col w-full lg:w-8/12 bg-white rounded-3xl shadow-xl h-[90vh] overflow-hidden border border-gray-100">
          {/* <div className="bg-emerald-100/30 px-6 py-4 border-b border-gray-200 text-lg font-semibold text-emerald-700">
            👩‍⚕️ Ask a Nurse
          </div> */}
  
          <div className="flex-grow overflow-y-auto px-6 py-4 space-y-4" ref={mainBoxRef}>
            {interactions.map((interaction, index) =>
              interaction.type === "question" ? (
                <div key={index} className="mb-2">
                  <Question text={interaction.text} />
                </div>
              ) : (
                <Answer key={index} text={interaction.text} />
              )
            )}
  
            {visible && (
              <div className="mx-2 mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-xl text-yellow-800 font-medium text-center shadow-sm animate-pulse">
                {data[lang]["Instructions"]}
              </div>
            )}
          </div>
  
          {/* Input */}
          <div className="bg-gray-50 px-4 py-3 flex items-center gap-2 border-t border-gray-200">
            <input
              placeholder="Type your question here..."
              className="flex-1 px-4 py-2 rounded-xl border border-gray-300 focus:ring-2 focus:ring-emerald-400 outline-none transition duration-200"
              onChange={handleText}
              onKeyDown={handleKeyDown}
              value={input}
            />
            <button
              className="bg-gradient-to-r from-emerald-500 to-green-600 text-white px-6 py-2 rounded-xl font-semibold hover:scale-105 hover:shadow-lg transition duration-300"
              onClick={() => askQuestion(input)}
            >
              Send
            </button>
          </div>
        </div>
  
        {/* Symptom Tracker */}
        <div className="w-full lg:w-4/12 bg-white rounded-3xl shadow-xl p-6 h-[90vh] overflow-y-auto border border-gray-100">
          <h2 className="text-2xl font-bold text-indigo-700 mb-6 text-center">
            🩺 Symptom Tracker
          </h2>
          <div className="grid grid-cols-2 gap-4">
            {data[lang]["Symptoms"].map((text, index) => (
              <button
                key={index}
                className="bg-gradient-to-br from-emerald-50 to-white hover:from-emerald-100 hover:to-white text-emerald-800 border border-emerald-200 rounded-xl px-4 py-2 shadow-sm hover:shadow-md text-sm font-medium transition duration-300"
                onClick={() => askQuestion(text)}
              >
                {text}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default Ask;
